import { Skeleton } from "../../../components/loading";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import useProductCountQuery from "./hooks/useProductCountQuery";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

export const ProductCountCard = (props: { vendorId: number }) => {
  const { count, loading } = useProductCountQuery(props.vendorId);

  return (
    <Box width="100%">
      <OutlinedPaper>
        <Stack id="product-count" gap={1} alignItems="center" p={2}>
          <Typography variant="h4">Number of Products</Typography>
          <Skeleton isLoading={loading} width={40} height={20}>
            <Typography variant="h2">{count}</Typography>
          </Skeleton>
        </Stack>
      </OutlinedPaper>
    </Box>
  );
};
